import { Link } from 'react-router-dom'

export default function CTA() {
  return (
    <section
      id="contact"
      className="bg-gradient-to-br from-[#0B1F45] to-[#162d5e] py-24 px-6 text-center text-white"
    >
      <div className="text-5xl font-bold">
        Ready to get started?
        <br />
        <span className="text-red-600">Your dashboard awaits.</span>
      </div>

      <p className="mt-6 text-white/60 max-w-xl mx-auto">
        Log in with your Optiva credentials to access client records and full
        advisory workspace.
      </p>

      <Link
        to="/login"
        className="mt-10 inline-block bg-red-600 px-10 py-4 rounded shadow-lg hover:-translate-y-1 transition"
      >
        Sign In to Your Account
      </Link>
    </section>
  )
}
